const dtGenerator     = require ('../../../../../components/dt/dt-generator')
const dtHandler       = require ('../../../../../components/dt/dt-handler')
const dtSearch        = require ('../../../../../components/dt/dt-search')
const dtSearchHandler = require ('../../../../../components/dt/dt-search-handler')
const sentpaymentMenu = require ('./sentpayment-menu')
const {organizeRow}       = require ('./sentpayment-dt-handler')
const {tableDetail}       = require ('./sentpayment-dt-handler')
const {updatePrintedRows} = require ('./sentpayment-dt-handler')

/****************ELEMENTS*****************/
var htmlDt          = {}
var HTMLwasSelected = false

function HTMLselect(){ 

      dtHandler.HTMLselect('sentpayment-dt', htmlDt, organizeRow, tableDetail)
      htmlDt.regularSearchFilter = Array.from(htmlDt.searchFilter).filter((input) => {
            return !input.id.startsWith('sentpayment_quick_filter_')
      })
      HTMLwasSelected  = true

      // htmlDt.sortBy = 'date_edited'
      // htmlDt.sortDirection = "DESC"
            
}/**/
/****************ELEMENTS*****************/

export function start(detail){  //console.log('sentpayment-dt 5>', detail)
  
      if(!HTMLwasSelected) { HTMLselect() }
       
      obj[detail.act].start(detail)

}/**/

const obj = {
   
      //From fullcont connection    
      addRow:         { start: (detail)=>{  dtGenerator.addRow( detail, htmlDt  )     }},
      tableOptions:   { start: (detail)=>{  sentpaymentMenu.start(detail, htmlDt, 'htmlFc')  }},
      trMenu:         { start: (detail)=>{  sentpaymentMenu.start(detail, htmlDt, 'htmlFc')  }},
      updateRow:      { start: (detail)=>{  dtGenerator.updateRow(detail, htmlDt)     }},
      updatePrintedRows: { start: (detail)=>{ updatePrintedRows(detail.rows)           }},

      //data table
      filter:         { start: (detail)=>{  dtSearch.filter(detail, htmlDt )          }},
      filterShowHide: { start: (detail)=>{  filterShowHide(detail)                    }},
      filterGenerated:{ start: (detail)=>{  setGeneratedFilter(detail, true)          }},
      showAllPayments:{ start: (detail)=>{  setGeneratedFilter(detail, false)         }},
      loadMore:       { start: (detail)=>{  dtSearch.loadMore(detail, htmlDt )        }},
      searching:      { start: (detail)=>{  dtSearch.searching(detail, htmlDt )       }},
      select:         { start: (detail)=>{  dtSearch.select(detail, htmlDt, true )    }},
      th:             { start: (detail)=>{  dtSearch.th(detail, htmlDt )              }},
      trPrint:        { start: (detail)=>{  trPrint(detail)                           }},

}/**/

function trPrint (detail){ }//console.log(' trPrint>')   }

function getQuickFilterInputs() {
      return {
            active: htmlDt.entityDt.querySelector('#sentpayment_quick_filter_check_active'),
            status: htmlDt.entityDt.querySelector('#sentpayment_quick_filter_check_status')
      }
}

function setGeneratedFilter(detail, enabled) {
      const quickFilter = getQuickFilterInputs()

      quickFilter.active.value = enabled ? 'true' : ''
      quickFilter.status.value = enabled ? 'Generated' : ''
      dtSearchHandler.cleanDt(htmlDt)
      dtSearch.select(detail, htmlDt, true)
}

function filterShowHide(detail) {
      const allSearchFilters = htmlDt.searchFilter
      htmlDt.searchFilter = htmlDt.regularSearchFilter
      const cancelReload = dtSearchHandler.filterShowHide(htmlDt)
      htmlDt.searchFilter = allSearchFilters

      if (cancelReload) { return }

      dtSearchHandler.cleanDt(htmlDt)
      dtSearch.select(detail, htmlDt, true)
}
